module.exports = __webpack_public_path__ + "img/purple.35f018f.webp";